/* eslint-disable no-alert */
/* eslint-disable import/no-unresolved */
import { AUTH_API } from 'apis';
import { useMutation } from 'react-query';

const errorHandler = (error) => {
  const { response } = error;
  if (response) {
    const { message } = response.data;
    window.alert(message);
  }
};

// SMS
export const getUserIdByPhoneAndSignid = async (params) => {
  const { data } = await AUTH_API.post(`account/v1/find/phone-signid/userid`, params);
  return data;
};

export const sendCertificationSMS = async (params) => {
  const { data } = await AUTH_API.post(`account/v1/certification/send/sms`, params);
  return data;
};

export const checkCertificationSMS = async (params) => {
  const { data } = await AUTH_API.get(`account/v1/sms`, { params });
  return data;
};

// Email
export const getUserIdByEmailAndSignid = async (params) => {
  const { data } = await AUTH_API.post(`account/v1/find/email-signid/userid`, params);
  return data;
};

export const sendCertificationEmail = async (params) => {
  const { data } = await AUTH_API.post(`account/v1/certification/send/email`, params);
  return data;
};

export const checkCertificationEmail = async (params) => {
  const { data } = await AUTH_API.post(`account/v1/certification/email`, params);
  return data;
};

// Password
export const updatePassword = async (params) => {
  const { data } = await AUTH_API.put(`account/v1/find/password`, params);
  return data;
};

// SMS
// SMS 인증번호 발송 요청
export const useSendCertificationSMS = () => {
  return useMutation(['sendCertificationSMS'], (params) => sendCertificationSMS(params));
};

// SMS 인증번호 확인 요청
export const useCheckCertificationSMS = (onSuccess) => {
  return useMutation(['checkCertificationSMS'], (params) => checkCertificationSMS(params), {
    onSuccess: () => {
      onSuccess();
      window.alert('인증이 완료 되었습니다.');
    },
    onError: (error) => error && errorHandler(error)
  });
};

// 폰번호와 로그인 아이디로 userId 조회
export const useUserIdByPhoneAndSignId = (onSuccess) => {
  const { mutateAsync } = useSendCertificationSMS();
  return useMutation(['getUserIdByPhoneAndSignid'], (params) => getUserIdByPhoneAndSignid(params), {
    onSuccess: async (data, params) => {
      const { userId } = data;
      if (userId && params.phone) {
        const { expireSecond } = await mutateAsync({ userId, phone: params.phone });
        await onSuccess(userId, expireSecond);
        window.alert('인증번호가 발송 되었습니다.');
      }
    },
    onError: (error) => error && errorHandler(error)
  });
};

// Email
// 인증 이메일 전송
export const useSendCertificationEmail = () => {
  return useMutation(['sendCertificationEmail'], (params) => sendCertificationEmail(params));
};

// 이메일 인증번호 확인 요청
export const useCheckCertificationEmail = (onSuccess) => {
  return useMutation(['checkCertificationEmail'], (params) => checkCertificationEmail(params), {
    onSuccess: () => {
      onSuccess();
      window.alert('인증이 완료 되었습니다.');
    },
    onError: (error) => error && errorHandler(error)
  });
};

// 이메일과 로그인 아이디로 userId 조회
export const useUserIdByEmailAndSignId = (onSuccess) => {
  const { mutateAsync } = useSendCertificationEmail();
  return useMutation(['getUserIdByEmailAndSignid'], (params) => getUserIdByEmailAndSignid(params), {
    onSuccess: async (data, params) => {
      const { userId } = data;
      if (userId && params.email) {
        const { expireSecond } = await mutateAsync({
          userId,
          email: params.email,
          emailType: 'PASSWORD_CERTIFICATION_KEY'
        });
        await onSuccess(userId, expireSecond);
        window.alert('메일이 발송 되었습니다.');
      }
    },
    onError: (error) => error && errorHandler(error)
  });
};

// Password
// 비밀번호 변경
export const useUpdatePassword = (onSuccess) => {
  return useMutation(['updatePassword'], (params) => updatePassword(params), {
    onSuccess: () => {
      window.alert(`새로운 비밀번호로 설정되었습니다.\n다시 로그인해주세요.`);
      onSuccess();
    },
    onError: (error) => error && errorHandler(error)
  });
};
